<div class="personal-details-form">
  <!-- Legal name -->
  <ng-container *ngIf="isShown('legalName')">
    <mat-form-field appearance="outline" class="full-width">
      <mat-label>{{ 'Full Legal Name' | translate }}</mat-label>
      <input
        matInput
        [ngModel]="legalName"
        (ngModelChange)="onNameChange($event)"
        autocomplete="off"
        data-testid="pdf-legal-name"
      />
    </mat-form-field>
  </ng-container>

  <!-- Date of birth -->
  <div *ngIf="isShown('dateOfBirth')" class="field-block">
    <app-input-date
      [ngModel]="dateOfBirth"
      (ngModelChange)="onDateChange($event)"
      [placeholder]="'Date of Birth' | translate"
      data-testid="pdf-dob"
    ></app-input-date>
  </div>

  <!-- CPF — plain, format-only (NO leak check) -->
  <div *ngIf="isShown('cpf')" class="field-block" data-testid="pdf-cpf">
    <app-question-cpf
      [question]="cpfQuestion"
      (changeAnswer)="onCpfChange($event)"
    ></app-question-cpf>
  </div>
</div>
